import { render, staticRenderFns } from "./IconDocument.vue?vue&type=template&id=29f424f4&"
import script from "./IconDocument.vue?vue&type=script&lang=js&"
export * from "./IconDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports